import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
    name:'auth',
    initialState:{
        isLoggedIn:true,
        token:null,
        userName:null,
        email:null,
        role:null
    },
    reducers:{
        login:(state,action)=>
        {
            console.log('action.payload',action.payload)
            return{
                ...state,
                isLoggedIn:true,
                token:action.payload.token,
                // refreshToken:action.payload.remember_token,
                userName:action.payload.userName,
                email:action.email,
                role:action.role,
              }
        },logout:(state,action)=>
        {
            return{
                isLoggedIn:false,
                token:null,
                userName:null,
                email:null,
                role:null,
              }
        }
    }
})

export const {login,logout} = authSlice.actions

export default authSlice.reducer